// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"26d8af6f","617":"1991cc6e","847":"f26fe153"}[chunkId] + ".chunk.js";
};